export default __webpack_public_path__ + "static/right-8557374334b5697632877c92506309b3.png";